import { statuses } from "../lib/utils";

export default function StatusBadge({ status }: { status: string }) {
  return <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${statuses[status] || "bg-slate-100 text-slate-700"}`}>{status}</span>;
}
